<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div id="application-page-container">
        <div id="application-page">
            <div id="title">
               اپلیکیشن
                <span>
                کانادا از ایران
            </span>
            </div>
            <div id="main-content" v-if="infos" v-html="infos.explain"></div>
            <div id="footer-content" v-if="infos">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12  mt-2" v-if="infos.android_link">
                        <img class="phone-pics" src="../assets/new/New/PicsSamsung.png" alt="">
                        <ul>
                            <li>
                                <img width="50" height="50"  src="../assets/new/New/android.png" alt="">
                            </li>
                            <li class="btn-style">
                                <a :href="infos.android_link"  target="_blank">
                                    <img width="26" height="30" src="../assets/new/New/google-play.png" alt="">
                                      <span>
                                        دریافت نسخه اندروید از
                                          <br/>
                                        <span class="brand-name">
                                          گوگل پلی
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-2" v-if="infos.ios_link">
                        <img class="phone-pics" src="../assets/new/New/PicsIphone.png" alt="">
                        <ul>
                            <li>
                                <img width="50" height="50" src="../assets/new/New/apple.png" alt="">
                            </li>
                            <li class="btn-style">
                                <a :href="infos.ios_link"  target="_blank">
                                    <img width="26" height="30" src="../assets/new/New/ios.png" alt="">
                                               <span>
                                        دریافت نسخه اندروید از
                                                    <br/>
                                        <span class="brand-name">
                                            سیب اپ
                                        </span>
                                    </span>
                                </a >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="loadingMood">
                <div style="height: 200px;padding-top: 50px;;margin: auto">
                    <img style="height: auto;width: 70%" src="../assets/loader/ezgif.com-gif-maker(1).gif" alt="loader">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "application-page",
        components:{
            Alert,
        },
        data(){
            return {
                alertContent: null,
                loadingMood: false,
                infos:null,
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getPageInfos/apkPage',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.loadingMood = false;
                    this.infos = response.data.results;

                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style lang="scss" scoped>
    #footer-content{
        overflow: hidden;
    }
    .btn-style{
        min-height: 60px;
        a{
            padding: 10px;
            //margin-top: 15px;
            width: 100%;
            height: 100%;
            border: solid 2px #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                margin:0 15px;
                span{
                    font-size: 17px;
                    font-weight: 900;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: right;
                    color: #162336;
                }
            }
            image{

            }
        }
    }
    ul{
        padding: 0;
        margin-top: 15px;
        list-style-type: none;
        display: flex;
        align-items: center;
        justify-content: center;
        li{
            display: inline-block;
            width: auto;
            margin: 0 15px;
        }
    }
    .phone-pics{
        width: 100%;
        max-width: 220px;
        height: auto;
    }

    #application-page-container{
        width: 100%;
        height: auto;
        background-color: white;
    }
    #main-content{
        padding-top: 50px;
        padding-bottom: 50px;
        text-align: right;
        overflow: hidden;
    }

    #application-page{
        max-width: 1120px;
        width: 100%;
        background-color: white!important;
        margin: auto;
        padding: 50px 15px;

        #title{
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
</style>